import _ from "lodash";
import {fetchDirsWithParent} from "../../../../firestore/dirs";

export const autoComplateChild = {
  methods: {
    fire() {
      if(this.$route.query.plan || (this.$store.state.project.plan && this.$store.state.project.plan.id) && (this.type || this.$route.params.type) === 'JOB') {
        return myFirestore
          .collection('projects')
          .doc(this.$store.state.project.id)
          .collection('plan')
          .doc(this.$route.query.plan || (this.$store.state.project.plan && this.$store.state.project.plan.id))
      }
      return myFirestore
        .collection('projects')
        .doc(this.$store.state.project.id)
    },
    getWork(id) {
      return myFirestore
        .collection('projects')
        .doc(this.$store.state.project.id).collection('works_type')
        .doc(id).get()
    },
    fetchJobs() {
      return new Promise((resolve, reject) => {
        let req = null;
        req = this.fire()
          .collection('jobs')
          .where('type', '==', 'PROF')
          .where(`objects`, 'array-contains-any', [this.obj && this.obj.id || 'all']);

        let result = [];
        req.get()
          .then((data) => {
            data.forEach((subDoc) => {
              const data = subDoc.data();
              result.push({
                id: subDoc.id,
                ...data,
              });
            });
          })
          .finally(() => {
            const result_filter = (result) => {
              return result
            }

            resolve(_.orderBy(result_filter(result), 'index', ['asc']))
          });
      })
    },
    async autoComplete(completeType) {
      const jobs = await this.fetchJobs();
      const worker = jobs.find((j) => j.name === 'Рабочие')

      const result = {
        daily_plan: {
          itr: "",
          workers: ""
        },
        jobs: [],
        jobs_internal: [],
        turn: {
          label: 1,
          value: 1
        },
        work_type: [],
        work_type_dir: [],
      }

      const workTypes = []
      const dirsTypes = []
      for (const {job} of this.form.jobs) {
        if(job.unit) {
          const type = workTypes.find((w) => w.work_type === job.work_type);

          if(!type) {
            workTypes.push({work_type: job.work_type})

            const workDetail = await this.getWork(job.work_type)
            const dir = await fetchDirsWithParent((workDetail && workDetail.data() && workDetail.data().dir), this.$store.state.project.id)

            if (completeType === 'dir' && dirsTypes.includes(dir.id)) {

            } else {
              if(dir) {
                dirsTypes.push(dir.id)
              }
              if (!completeType) {
                result.work_type.push({
                  id: job.work_type,
                  label: job.work_type_name,
                  value: {
                    id: job.unit_id,
                    isMain: true,
                    label: job.unit,
                    value: job.unit_id
                  }
                })
              }

              if(dir) {
                result.work_type_dir.push({
                  id: dir.id,
                  value: dir.id,
                  label: dir.name,
                })
              }

              if (worker) {
                result.jobs.push([{
                  is_daily: true,
                  is_select: null,
                  job: {
                    ...worker,
                    work_type: completeType ? null : job.work_type,
                    work_type_name: completeType ? null : job.work_type_name,
                  } || {},
                  plan: 0,
                  time: "",
                  total: 0,
                  value: "",
                  work_type: completeType ? null : job.work_type
                }])
              } else {
                result.jobs.push([]);
              }
            }
          }
        }
      }

      this.childForm[this.openType] = result
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/Dashboard/Reports/mixins/autocomplateChild.js